<template>
<div>
    <div id="div-filtros-cpdaud">
         <div class="reloj">
               {{hora}}
           </div>
           <div class="filtros-busqueda">
               <select name="partido" id="Partido" class='form-control campos' v-model="PartidoJudicial" @change="ObtenerAudiencias" required>
                 <option value="0" selected>Todos</option>
                 <option v-for="(partido,index) in CATALOGOS.partidoJudicial" :key="index" :value="partido.llave">{{partido.valor}}</option>  
                 <!-- <option value="1">Aguascalientes</option>
                 <option value="2">Calvillo</option>
                 <option value="3">Pabellón de Arteaga</option>
                 <option value="4">Rincón de Romos</option>
                 <option value="5">Jesús María</option>
                 <option value="6">Adolescentes</option>
               -->
             </select>

             <input type="date" class='form-control campos' v-model="Fecha" @change="ObtenerAudiencias"/>
             <!-- </div> -->
             <!-- <button type="button" class="btn btn-info" @click="ObtenerAudiencias">Ir a Fecha</button> -->
           </div>
           <!-- <div class="reloj">
               {{hora}}
           </div> -->
        </div>

    <div id="div-tabla">
           <h6></h6>
           <table 
                class="table table-striped table-light table-hover letra-grande"
                id='tabla-audiencas'             
                data-toggle="table"
                data-undefined-text="-"  
                data-click-to-select="false"
                
           >
           <thead  class="thead-dark">
               <tr>
                   <!-- <th data-halign="center" data-width="6" data-align="center"  data-field="audiencia_id">FOLIO</th> -->
                   <th data-halign="center" data-align="center"  data-field="NombrePartido">MUNICIPIO</th>
                 <th data-halign="center"  data-align="center"  data-field="ConDetenido">DETENIDO</th>
                 <th data-halign="center" data-align="center"  data-field="FechaDeAudiencia">FECHA DE AUDIENCIA</th>
                   <th data-halign="center" data-align="center"  data-field="HoraDeAudiencia">HORA</th>
                    <th data-halign="center" data-align="center"  data-field="CarpetaCompleta">CARPETA</th>                
                   <th data-halign="center" data-align="center"  data-field="Sala">SALA</th>
                   <th data-halign="center" data-align="center"  data-field="zoom_id">ID ZOOM</th>
                   <th data-halign="center" data-align="center"  data-field="audiencia_tipo">AUDIENCIA</th>
                   <th data-halign="center" data-align="center"  data-field="audiencia_auxiliar">AUXILIAR</th>
                   <th data-halign="center" data-align="center"  data-field="audiencia_1_juez">JUEZ</th>
                    <th data-halign="center" data-align="center"  data-field="audiencia_status">ESTADO</th>
               </tr>
           </thead>

           </table>
       </div>

</div>
</template>


<script>
import axios from 'axios';
import api from '@/../static/js/api'
import {CATALOGOS} from "@/components/Audiencias/Catalogos/CatalogosBD.js"
import moment from 'moment'

export default{
    data(){
            return{
                CATALOGOS,
                Fecha:moment().format('YYYY-MM-DD'),
                PartidoJudicial:0,
                hora:null
            }
        },
    methods:{
        ObtenerAudiencias: async function(){
        //  clearInterval();
           
            let parametros = {
                Fecha:  this.Fecha,
                PartidoJudicial:this.PartidoJudicial
            }
            const RESPUESTA = await axios.post(api.conexion+'Audiencias/AgendaControlAux/AgendaControlAuxInformatica',parametros,null);
         

            //return await RESPUESTA;
              let Datos = await this.formatoAudienciasJuez(await RESPUESTA.data.Audiencias);
            $("#tabla-audiencas").bootstrapTable({data:await Datos.filter(a=>a.audiencia_show==1 )});
            $("#tabla-audiencas").bootstrapTable("load",await Datos.filter(a=>a.audiencia_show==1 ));
            //  console.log("fin del metodo::",await Datos)

             
        
      //  await setInterval(this.ObtenerAudiencias,8000)
        
        },
        // ObtenerAudienciasPorGrupo:async function(){
         
        //    let Respuesta = await this.ObtenerAudiencias
            
        // },
        formatoAudienciasJuez:async function(doc){
            let documento
            documento = doc.map(c => {
                let docFormateado = c;
                var NombrePartido =CATALOGOS.partidoJudicial.filter(a=>a.llave==c.partido_id);
                docFormateado.Sala = (c.audiencia_sala!=null)?c.audiencia_sala+" "+c.audiencia_modo : "-";
                docFormateado.FechaDeAudiencia = (c.audiencia_fecha!=null)?moment(c.audiencia_fecha,"YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY"):"-"; 
                docFormateado.HoraDeAudiencia = (c.audiencia_fecha!=null)?moment(c.audiencia_fecha,"YYYY-MM-DD HH:mm:ss").format("HH:mm"):"-";
                docFormateado.NombrePartido = NombrePartido[0].valor;
                docFormateado.FechaAgendada = (c.audiencia_registrada!=null)?moment(c.audiencia_registrada,"YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY"):"-";
                docFormateado.ConDetenido = (c.audiencia_detenido == 1)?"Si":"No";
                let tipoDeCarpeta = CATALOGOS.tiposCarpetas.find(s=>s.llave==c.carpeta_tipo_id);
                let tipoCarpetaStr = (tipoDeCarpeta != null && tipoDeCarpeta != undefined) ? tipoDeCarpeta.valor : '';
                docFormateado.CarpetaCompleta = `${tipoCarpetaStr} ${c.carpeta_alias}`
                return docFormateado;
            });
            return documento;
        },
      

 Reloj:function () {
     var today = new Date();
     var hr = today.getHours();
     var min = today.getMinutes();
     var sec = today.getSeconds();
     //Add a zero in front of numbers<10
     min = this.checkTime(min);
     sec = this.checkTime(sec);   
     this.hora =  hr + " : " + min + " : " + sec;
    
 },
 checkTime:function(i)  {
     if (i < 10) {
         i = "0" + i;
     }
     return i;
 },

        
        
    },
    mounted(){
        this.Reloj();
      // setTimeout(()=>{ this.Reloj() }, 500);
      $("#tabla-audiencas").bootstrapTable({data:[] });
        $("#tabla-audiencas").bootstrapTable("load",[] );

        this.ObtenerAudiencias();
    
setInterval(()=>{ this.Reloj() }, 1000);
setInterval(async ()=>{ await this.ObtenerAudiencias() }, 100000);
      
//this.ObtenerAudienciasPorGrupo();
//  setInterval(() => {
//      console.log("ejecuta::")
//    this.ObtenerAudiencias();
//  }, (1000 * 60));
  
	
 
    },
     created(){
        
    }
}


</script>
<style scoped>
#div-filtros-cpdaud {
    margin-bottom: -3.5em;
}
#div-tabla table {
    margin-top: -2em;
}
.letra-grande{
    font-size: 1.2em;
    font-weight: bold;
    font-family:'Open Sans', sans-serif;
}
.reloj{
    /* position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    margin-right: .5em; */
    font-weight: bold;
    font-size: 3em;
    display: flex;
    justify-content: center;
    padding-bottom: 0.5em;

}
.campos{
    width: 20%;
}
#encabezados-tp {
    margin-bottom: 4em;
    width: 100%;
    text-align: center;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
    font-size: 2.5em;
}

#encabezados-tp h3 {
    font-size: 1.5em;
    color: rgb(175, 175, 175);
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}
.filtros-busqueda {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1em;
    flex-wrap: wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Audiencias/Temporal/CConsultaPublica.vue